import { useMemo } from 'react';
import { prop } from 'ramda';
import { useFormsSelector } from 'js/store/hooks';

export const useIsFormAvailable = (formName: string): boolean => {
    const forms = useFormsSelector(prop('forms'));

    return useMemo(() => forms.some((form) => form.name === formName), [forms, formName]);
};
